import { GridState } from "@ag-grid-community/core";
import { AgGridReactProps } from "@ag-grid-community/react";
import {
  FUND_FAMILY_FILTER,
  STUB_CALCULATION,
} from "features/transactions/TransactionsViewTable/CalculationActions/constants";
import { useFundFamilyListSuspense } from "gen/endpoints/fund-family/fund-family";
import { useCallback, useEffect, useMemo, useState } from "react";
import { DataTableRef } from "shared/components/table/data/DataTable";

export const useCalculationActions = (
  ref: React.RefObject<DataTableRef>,
  initialState: GridState,
) => {
  const { data: fundFamilies } = useFundFamilyListSuspense();
  const [transactionCalculationId, setTransactionCalculationId] = useState<
    string | null | undefined
  >(
    initialState.aggregation?.aggregationModel[0]?.aggFunc ||
      STUB_CALCULATION.id,
  );

  const [fundFamilyIds, setFundFamilyIds] = useState<string[]>(
    fundFamilies.map((ff) => ff.id!),
  );
  const api = ref.current?.tableRef?.api;

  // this hook syncs the header bar state with the ag grid filter state
  useEffect(() => {
    if (api) {
      const oldFilterModel = api.getFilterModel();
      const newFilterModel = {
        ...oldFilterModel,
        [FUND_FAMILY_FILTER]: {
          values: [...fundFamilyIds],
          filter_type: "set",
        },
      };
      api.setFilterModel(newFilterModel);
    }
  }, [fundFamilyIds, api]);
  // this event handlers syncs the other direction, the ag grid state with the header bar input state
  const onFilterChanged = useCallback<
    NonNullable<AgGridReactProps["onFilterChanged"]>
  >(
    (event) => {
      const filterModel = event.api.getFilterModel();
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const fundFamilyIds = filterModel[FUND_FAMILY_FILTER]?.values;

      if (fundFamilyIds === undefined) {
        setFundFamilyIds(fundFamilies.map((ff) => ff.id!));
      } else {
        setFundFamilyIds(fundFamilyIds);
      }
    },
    [fundFamilies, setFundFamilyIds],
  );

  const sideBar: AgGridReactProps["sideBar"] = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: false,
            suppressValues: true,
            suppressPivots: false,
            suppressPivotMode: false,
          },
        },
        "filters",
      ],
      hiddenByDefault: true,
    }),
    [],
  );

  return {
    fundFamilyIds,
    setFundFamilyIds,
    transactionCalculationId,
    setTransactionCalculationId,
    onFilterChanged,
    sideBar,
  };
};
